export const characters: Record<string, string> = {
	char_green_name: "Green",
	char_blue_name: "Blue",
	char_red_name: "Red",
	char_green_desc: "Solidificador: prende inimigos em blocos sólidos",
	char_blue_desc: "Arma Criogênica: alcance menor, congela o alvo e inimigos próximos",
	char_red_desc: "Cutelo: corpo a corpo, avança em inimigos próximos",
	char_blue_unlockHint: "Complete o nível 4",
	char_red_unlockHint: "Chegue às cavernas",
};
